/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accountMgmtSuperAdminTerminal.vue?vue&type=template&id=8701b7d6&scoped=true"
import script from "./accountMgmtSuperAdminTerminal.vue?vue&type=script&lang=js"
export * from "./accountMgmtSuperAdminTerminal.vue?vue&type=script&lang=js"
import style0 from "./accountMgmtSuperAdminTerminal.vue?vue&type=style&index=0&id=8701b7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8701b7d6",
  null
  
)

export default component.exports